<div class="container mx-auto device-firmware-content">
    <form #form="ngForm" class="form container-fluid pl-0 pr-0">
        <div class="hero-text" fxLayout="row" fxFlexAlign="center" style="margin-left: 10px;">
            <h1 style="font-weight: 800;">{{'DEVICE_FIRMWARE_UPDATE' | translate}}</h1>
        </div>
        <div class="device-input">
            <mat-form-field appearance="outline" floatLabel="always" class="w-100-p">
                <mat-label>{{'CHOOSE_FIRMWARE'|translate}}</mat-label>
                    <mat-select placeholder="{{'CHOOSE_FIRMWARE'|translate}}" name="firmware" [(ngModel)]="selectedFirmware" required>
                        <mat-option *ngFor="let item of firmware" [value]="item">{{item.version}}</mat-option>
                    </mat-select>
            </mat-form-field>
        </div>
        <button style="margin-left: 10px; margin-top: 10px; margin-bottom: 10px;" mat-raised-button (click)="save()">
            <span>{{'CREATE'|translate}}</span>
        </button>
    </form>
</div>